export const MENUITEMS = [
  {
    Items: [
      {
        path: "/superadmin/dashboard",
        icon: "fa fa-home",
        type: "link",
        active: true,
        selected: true,
        title: "Dashboard",
      },
      
      // {
      //   path: "/superadmin/studentdashboard",
      //   icon: "fa fa-home",
      //   type: "link",
      //   active: false,
      //   selected: false,
      //   title: "manager Dashboard",
      // },
      // {
      //   path: "/superadmin/teacherdashboard",
      //   icon: "fa fa-home",
      //   type: "link",
      //   active: false,
      //   selected: false,
      //   title: "Staff Dashboard",
      // },
      {
        title: "Master",
        icon: "fa fa-database",
        type: "sub",
        active: false,
        selected: false,
        children: [
          // {
          //   path: "/master/rolelist",
          //   type: "link",
          //   active: false,
          //   selected: false,
          //   title: "Role",
          // },
          {
            path: "/master/schemelist",
            type: "link",
            active: false,
            selected: false,
            title: "Scheme",
          },
          {
            path: "/master/branchlist",
            type: "link",
            active: false,
            selected: false,
            title: "Branch",
          },
          {
            path: "/master/designationlist",
            type: "link",
            active: false,
            selected: false,
            title: "Designation",
          },
          {
            path: "/master/religionlist",
            type: "link",
            active: false,
            selected: false,
            title: "Religion",
          },
          {
            path: "/master/castelist",
            type: "link",
            active: false,
            selected: false,
            title: "Caste",
          },
          {
            path: "/master/subcastelist",
            type: "link",
            active: false,
            selected: false,
            title: "Subcaste",
          },
        ],
      },
      {
        title: "Staff",
        icon: "fa fa-user",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/staff/addstaff",
            type: "link",
            active: false,
            selected: false,
            title: "Add staff",
          },

          {
            path: "/staff/allstaff",
            type: "link",
            active: false,
            selected: false,
            title: "All Staff",
          },
          {
            path: "/staff/deletedstaff",
            type: "link",
            active: false,
            selected: false,
            title: "Deleted Staff",
          },
          // {
          //   path: "/staff/editstaff",
          //   type: "link",
          //   active: false,
          //   selected: false,
          //   title: "Edit Staff",
          // },


        ],
      },
      {
        title: "Group",
        icon: "fa fa-address-book sidemenu-icon menu-icon",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/group/addgroup",
            type: "link",
            active: false,
            selected: false,
            title: "Add Group",
          },
          {
            path: "/group/allgroup",
            type: "link",
            active: false,
            selected: false,
            title: "All Group",
          },
          {
            path: "/group/deletedgroup",
            type: "link",
            active: false,
            selected: false,
            title: "Deleted Group",
          },
         
          // {
          //   path: "/timetable/alltimetable",
          //   type: "link",
          //   active: false,
          //   selected: false,
          //   title: "Edit Group",
          // },
          
        ],
      },
     
      {
        title: "Members",
        icon: "fa fa-users",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/member/addmember",
            type: "link",
            active: false,
            selected: false,
            title: "Add Member",
          },
          {
            path: "/member/allmembers",
            type: "link",
            active: false,
            selected: false,
            title: "All Members",
          },
          {
            path: "/member/deletedmembers",
            type: "link",
            active: false,
            selected: false,
            title: "Deleted Members",
          },

         

        ],
      },
      {
        title: "Loan",
        icon: "fa fa-credit-card",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/loan/loanapproval",
            type: "link",
            active: false,
            selected: false,
            title: "Pending Loan",
          },
          {
            path: "/loan/allloan",
            type: "link",
            active: false,
            selected: false,
            title: "All Loans",
          },
          {
            path: "/loan/deletedloan",
            type: "link",
            active: false,
            selected: false,
            title: "Deleted Loans",
          },
          
        ],
      },
      {
        title: "Collection",
        icon: "fa fa-money",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/collection/addcollection",
            type: "link",
            active: false,
            selected: false,
            title: "Recovery Posting"
            // title: "Add Collection",
          },
          {
            path: "/collection/allcollection",
            type: "link",
            active: false,
            selected: false,
            title: "All Collection",
          },
         
        ],
      },
      {
        title: "Pre Loan Collection",
        icon: "fa fa-money",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/preloan/addcollection",
            type: "link",
            active: false,
            selected: false,
            title: "Pre Loan Posting"
          },
          {
            path: "/preloan/listcollection",
            type: "link",
            active: false,
            selected: false,
            title: "Pre Loan List"
          },
        ],
      },
      {
        title: "BM & AM Report",
        icon: "fa fa-clipboard",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/bmam/addreport",
            type: "link",
            active: false,
            selected: false,
            title: "Add Report",
          },
          {
            path: "/bmam/allreport",
            type: "link",
            active: false,
            selected: false,
            title: "All Reports",
          },
          {
            path: "/reports/bmamreport",
            type: "link",
            active: false,
            selected: false,
            title: "Daily Report",
          },
        ],
      },
      {
        title: "Attendance",
        icon: "fa fa-clock-o",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/attendance/markattendance",
            type: "link",
            active: false,
            selected: false,
            title: "Mark Attendance",
          },
          {
            path: "/attendance/attendancelist",
            type: "link",
            active: false,
            selected: false,
            title: "Attendance List",
          },
          {
            path: "/attendance/attendancereport",
            type: "link",
            active: false,
            selected: false,
            title: "Attendance Report",
          },
          {
            path: "/attendance/lateapprovals",
            type: "link",
            active: false,
            selected: false,
            title: "Late Clock In Approvals",
          },
          {
            path: "/attendance/leaveapprovals",
            type: "link",
            active: false,
            selected: false,
            title: "Leave Approvals",
          },
        ],
      },
      {
        title: "Payslip",
        icon: "fa fa-file-text",
        type: "sub",
        active: false,
        selected: false,
        children: [
          {
            path: "/payslip/salarystructure",
            type: "link",
            active: false,
            selected: false,
            title: "Salary Structure",
          },
          {
            path: "/payslip/bulkgenerate",
            type: "link",
            active: false,
            selected: false,
            title: "Bulk Generate",
          },
          {
            path: "/payslip/addpayslip",
            type: "link",
            active: false,
            selected: false,
            title: "Add Payslip",
          },
          {
            path: "/payslip/allpayslip",
            type: "link",
            active: false,
            selected: false,
            title: "All Payslip",
          },
        ],
      },
      // {
      //   title: "Income and Expences",
      //   icon: "fa fa-inr",
      //   type: "sub",
      //   active: false,
      //   selected: false,
      //   children: [
      //     {
      //       path: "/superadmin/incomeexpences",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Income & Expences Dashboard",
      //     },

      //     {
      //       path: "/superadmin/income",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Add Income",
      //     },
          
      //     {
      //       path: "/superadmin/expences",
      //       type: "link",
      //       active: false,
      //       selected: false,
      //       title: "Add Expences",
      //     },
         
          
        
      //   ],
      // },
      {
        // path: "/superadmin/reports",
        icon: "fa fa-download",
        type: "sub",
        active: false,
        selected: false,
        title: "Reports",
        children: [
          {
            path: "/reports/dailycollectionsheet",
            type: "link",
            active: false,
            selected: false,
            title: "Daily Collection Sheet",
          },
          {
            path: "/reports/collectionsheet",
            type: "link",
            active: false,
            selected: false,
            title: "Weekly Collection Sheet",
          },
          {
            path: "/reports/staffwisecollection",
            type: "link",
            active: false,
            selected: false,
            title: "Staffwise Collection",
          },
          {
            path: "/reports/topcollectionsheet",
            type: "link",
            active: false,
            selected: false,
            title: "Top Collection Sheet",
          },
          // {
          //   path: "/reports/pendingcollectionsheet",
          //   type: "link",
          //   active: false,
          //   selected: false,
          //   title: "Pending Collection Sheet",
          // },
          {
            path: "/reports/summary",
            type: "link",
            active: false,
            selected: false,
            title: "Summary Report",
          },
          {
            path: "/reports/loandisbursement",
            type: "link",
            active: false,
            selected: false,
            title: "Loan Disbursement",
          },
          {
            path: "/reports/outstanding",
            type: "link",
            active: false,
            selected: false,
            title: "Outstanding Report",
          },
          {
            path: "/reports/preloanreport",
            type: "link",
            active: false,
            selected: false,
            title: "Pre Loan Report",
          },
          {
            path: "/reports/nocreport",
            type: "link",
            active: false,
            selected: false,
            title: "NOC Report",
          },
          {
            path: "/reports/denomination",
            type: "link",
            active: false,
            selected: false,
            title: "Denomination",
          },
          {
            path: "/reports/salaryreport",
            type: "link",
            active: false,
            selected: false,
            title: "Salary Report",
          },
          {
            path: "/reports/bmamreport",
            type: "link",
            active: false,
            selected: false,
            title: "BM & AM Daily Report",
          },

        ],
      },
     
     
      {
        path: "/superadmin/settings",
        title: "Settings",
        icon: "fa fa-cog",
        type: "link",
        active: false,
        selected: false,
      },
    ],
  },
];
